import { ChallengeModelShow } from './ChallengeModelShow';
import { ChallengeModelEdit } from './ChallengeModelEdit';
import { ChallengeModelCreate } from './ChallengeModelCreate';
import { ChallengeModelList } from './ChallengeModelList';

export default {
    list: ChallengeModelList,
    show: ChallengeModelShow,
    edit: ChallengeModelEdit,
    create: ChallengeModelCreate,
};
